import Vue from "vue";
import VueRouter from "vue-router";
import Cms from "./Cms";
import DashboardRoute from "@/router/Dashboard.js";
import ControlCenterRoute from "@/router/ControlCenter.js";
import BrandingRoute from "@/router/Branding.js";
import MarcomRoute from "@/router/Marcom.js";
import BuilderRoute from "@/router/Builder.js";
import StudioRoute from "@/router/Studio.js";
import ExtentionRoute from "@/router/Extention.js";
import AddonsRoute from "@/router/Addons.js";
import BillingRoute from "@/router/Billing.js";
import MyAdminRoute from "@/router/MyAdmin.js";

import jwt from "jsonwebtoken";
import store from "../store/store";
Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/admin-panel",
      component: () => import("@/views/adminPanel/layouts/AdminPanel.vue"),
      redirect: { name: "adminPanel" },

      children: [
        ...DashboardRoute,
        ...ControlCenterRoute,
        ...BrandingRoute,
        ...MarcomRoute,
        ...BuilderRoute,
        ...StudioRoute,
        ...ExtentionRoute,
        ...AddonsRoute,
        ...BillingRoute,
        ...MyAdminRoute,
        ...Cms,
      ],
    },

    //Full page Router
    {
      path: "",
      name: "none",
      // redirect: { name: "adminPanel-analytics" },
      redirect: { name: "login" },
      // redirect: "/login",
    },
    {
      path: "/blog",
      name: "marcomblog",
      component: () =>
        import("@/views/adminPanel/pages/landing/components/Blog1.vue"),
      meta: {
        rule: "editor",
      },
    },
    {
      path: "/blog2",
      name: "marcomblog2",
      component: () =>
        import("@/views/adminPanel/pages/landing/components/Blog2.vue"),
      meta: {
        rule: "editor",
      },
    },
    {
      path: "/blog3",
      name: "marcomblog3",
      component: () =>
        import("@/views/adminPanel/pages/landing/components/Blog3.vue"),
      meta: {
        rule: "editor",
      },
    },
    {
      path: "/blog4",
      name: "marcomblog4",
      component: () =>
        import("@/views/adminPanel/pages/landing/components/Blog4.vue"),
      meta: {
        rule: "editor",
      },
    },

    {
      path: "/login",
      name: "login",
      component: () =>
        import("@/views/adminPanel/pages/login-flow/Login-flow.vue"),
      meta: {
        rule: "editor",
      },
    },

    {
      path: "/forgot-password",
      name: "forgot-password",
      component: () =>
        import("@/views/adminPanel/pages/forgotpassword/ForgotPassword.vue"),
      meta: {
        rule: "editor",
        authRequired: false,
      },
    },

    {
      path: "/invoice",
      name: "invoice",
      component: () => import("@/views/adminPanel/pages/invoice/Invoice.vue"),
      meta: {
        rule: "editor",
      },
    },
    // {
    //   path: "/newpassword",
    //   name: "newpassword",
    //   component: () =>
    //     import("@/views/adminPanel/pages/login-flow/password/NewPassword.vue"),
    //   meta: {
    //     rule: "editor",
    //   },
    // },
    {
      path: "/hello",
      name: "hello",
      component: () => import("@/views/adminPanel/pages/login-flow/Hello.vue"),
      meta: {
        rule: "editor",
      },
    },
    {
      path: "/profile-v",
      name: "profile-v",
      component: () =>
        import("@/views/adminPanel/pages/login-flow/Profile.vue"),
      meta: {
        rule: "editor",
      },
    },

    {
      path: "/business",
      name: "business",
      component: () =>
        import("@/views/adminPanel/pages/login-flow/Business.vue"),
      meta: {
        rule: "editor",
      },
    },
    {
      path: "/fonts",
      name: "fonts",
      component: () => import("@/views/adminPanel/pages/login-flow/Fonts.vue"),
      meta: {
        rule: "editor",
      },
    },
    {
      path: "/color",
      name: "color",
      component: () => import("@/views/adminPanel/pages/login-flow/Color.vue"),
      meta: {
        rule: "editor",
      },
    },
    {
      path: "/step",
      name: "step",
      component: () => import("@/views/adminPanel/pages/login-flow/Step.vue"),
      meta: {
        rule: "editor",
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (from.name == null && to.path == "/login") {
    next();
  } else {
    if (Object.keys(store.state.admin.login).length > 0) {
      const user = store.state.admin.login;
      // try {
      //   const tokenVerify = jwt.verify(
      //     user.token,
      //     `p4sta.w1th-b0logn3s3-s@uceundefined`
      //   );
      //   console.log(
      //     tokenVerify,
      //     Date.now() / 1000,
      //     tokenVerify.exp > Date.now() / 1000,
      //     "TOKEN"
      //   );
      //   if (tokenVerify && tokenVerify.exp > Date.now() / 1000) {
      //     next();
      //   } else {
      //     next("/login");
      //   }
      // } catch (error) {
      //   next("/login");
      //   console.log(error, "JWT");
      // }
      jwt.verify(
        user.token,
        `p4sta.w1th-b0logn3s3-s@uceundefined`,
        function (err, tokenVerify) {
          if (tokenVerify && tokenVerify.exp > Date.now() / 1000) {
            next();
          } else {
            console.log(next(), "NEXT");
            next("/login");
            // console.log(tokenVerify, "VERIFY");
          }
        }
      );
    } else if (!to.meta.authRequired) {
      console.log(to.meta.authRequired, "LOG");
      next();
    } else {
      next("/login");
      // return { path: "/login", force: true };
    }
  }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});
export default router;
